import { render, staticRenderFns } from "./CuotasCard.vue?vue&type=template&id=638ceb83"
import script from "./CuotasCard.vue?vue&type=script&lang=js"
export * from "./CuotasCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports